



















import { snakeCase } from 'lodash'
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import { CashRegisterType } from './types'

@Component({
  data() {
    return {
      snakeCase,
    }
  }
})
export default class CashRegisterHint extends Vue {
  @Prop() type!: CashRegisterType

  isOpen = false
}
